import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

interface AboutModalProps {
  open: boolean;
  onClose: () => void;
}

const AboutModal: React.FC<AboutModalProps> = ({ open, onClose }) => {
  const handleClose = () => {
    console.log('AboutModal: Close function called');
    if (onClose) {
      onClose();
    }
  };

  const handleButtonClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    console.log('AboutModal: Continuer button clicked');
    handleClose();
  };

  const handleBackdropClick = (e: React.MouseEvent) => {
    console.log('AboutModal: Backdrop clicked');
    handleClose();
  };

  const handlePaperClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent modal content clicks from closing
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      disableEscapeKeyDown={false}
      onClick={handleBackdropClick}
      PaperProps={{
        onClick: handlePaperClick,
        sx: {
          width: { xs: '90vw', sm: '550px' },
          maxWidth: '95vw',
          background: 'rgba(24,29,38,0.95)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255,255,255,0.12)',
          borderRadius: '12px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
        }
      }}
      sx={{ 
        '& .MuiDialog-paper': { overflow: 'visible' },
        '& .MuiBackdrop-root': {
          backgroundColor: 'rgba(0,0,0,0.7)',
          backdropFilter: 'blur(5px)',
        },
        zIndex: 9999
      }}
    >
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between', 
        p: 1.2, 
        pb: 0.5, 
        fontWeight: 700, 
        fontSize: '1.18rem', 
        color: '#fff', 
        letterSpacing: 0.4, 
        background: 'transparent'
      }}>
        <span></span>
        <IconButton
          onClick={handleClose}
          sx={{
            color: '#fff',
            p: 0.5,
            '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' },
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
      <DialogContent sx={{ px: 3, py: 2 }}>
        <Typography 
          component="div"
          sx={{
            fontSize: '13px',
            color: '#fff',
            fontFamily: 'LouguiyaFR, sans-serif',
            whiteSpace: 'pre-wrap',
            background: 'none',
            margin: 0,
            padding: 0
          }}
        >
          <p style={{ textAlign: 'center', fontSize: '1.35rem', fontWeight: 'bold', margin: '0 0 16px 0' }}>Bienvenue sur MAADEN CARTO</p>

<p style={{ margin: '0 0 12px 0' }}>
MAADEN CARTO est un portail cartographique regroupant l'ensemble des données géospatiales liées à l'activité minière artisanale et semi-industrielle de l'or en Mauritanie. Il est destiné strictement à l'usage interne pour visualiser les données cartographiques de MAADEN (couloirs, mejhars, zones semi-industrielles, zones commerciales, centres de traitement, bases vie, ect). Il permet de situer des points GPS et vérifier leur appartenance aux couloirs, mesurer des distances sur la carte, ainsi qu'importer et visualiser directement des fichiers aux formats KMZ, SHP ou CSV.
</p>
<p style={{ margin: '0 0 4px 0' }}>
Pour toute remarque, anomalie ou demande d'assistance, veuillez contacter :
</p>
<ul style={{ marginTop: 0, marginBottom: 16, paddingLeft: 20 }}>
  <li>Email : <a href="mailto:eminbouka@maaden.gov.mr" style={{ color: '#4fc3f7', fontWeight: 700, textDecoration: 'underline' }}>eminbouka@maaden.gov.mr</a></li>
  <li>Téléphone : <b>28582110</b></li>
</ul>
          
          <p style={{ fontStyle: 'normal', color: '#fff', margin: '0 0 10px 0', textAlign: 'center' }}>
            MAADEN CARTO est développé 100 % in-house
          </p>
        </Typography>
        
        <Box sx={{ 
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          marginTop: 2,
          marginBottom: 1
        }}>
          <img 
            src="/HQ.png" 
            alt="MAADEN HQ" 
            style={{ 
              width: '220px',
              height: 'auto',
              marginBottom: '10px'
            }} 
          />
          <button 
            onClick={handleButtonClick}
            style={{ 
              backgroundColor: '#FFD700',
              color: 'black',
              fontSize: '14px',
              fontWeight: 'bold',
              padding: '12px 24px',
              borderRadius: '6px',
              border: 'none',
              cursor: 'pointer',
              minWidth: '120px',
              fontFamily: 'inherit'
            }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#FFC700'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#FFD700'}
          >
            Continuer
          </button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default AboutModal;
